import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactDOM from 'react-dom';
import { ModalContext } from '../ModalContext';
import ApiResult from '../ApiResult';

function Modal({ buttons, text, title, loading, size, errorObject, disableAllButtons, children }: { buttons: Array<any>, text?: string, title: string, loading?: boolean, size?: any, errorObject: any, disableAllButtons: any, children?: any|null}) {


    const [showModal, closeModal] = useContext(ModalContext);


    var modalClass = ['modal-dialog', 'modal-dialog-scrollable']
    if (size) {
        modalClass.push('modal-' + size)
    }

    return ReactDOM.createPortal(
        <>
            <div className="modal" style={{ display: 'block' }}  role="dialog">
                <div className={modalClass.join(' ')} role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closeModal} />


                        </div>
                        <div className="modal-body">
                            {
                                loading ?
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    : <>
                                    <ApiResult errorObject={errorObject} />
                                       
                                        {children ? children : text}
                                    </>
                            }
                        </div>
                        <div className="modal-footer">
                            {
                                disableAllButtons ?
                                    <div style={{ position: 'absolute', left: '10px' }}>
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                buttons.filter(item => !item.hidden).map(item => {
                                    return (
                                        <button disabled={disableAllButtons || loading || item.isDisabled} type="button" className={"btn btn-" + item.style} onClick={
                                            typeof (item.onClick) === 'string' && item.onClick === 'closeModal' ?
                                                closeModal
                                                : item.onClick
                                        }>{item.icon ? <FontAwesomeIcon icon={["fas", item.icon]} /> : null} {item.text}</button>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>,
        document.getElementById('modal') as HTMLElement
    );

}


export default Modal;
